(function () {
  var MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  var CATEGORY_LABELS = {
    stream: 'Stream',
    community: 'Community',
    new: 'New Content'
  };

  var DEFAULT_CATEGORY = 'stream';

  /* Standard-time UTC offsets for the US zones an event time might name. */
  var ZONE_STANDARD_OFFSETS = { e: -5, c: -6, m: -7, p: -8 };

  /* US daylight saving: 2nd Sunday in March → 1st Sunday in November. */
  function isUsDst(year, month, day) {
    function nthSunday(y, m, n) {
      var d = new Date(Date.UTC(y, m, 1));
      var offset = (7 - d.getUTCDay()) % 7;
      return 1 + offset + (n - 1) * 7;
    }
    if (month < 2 || month > 10) return false;
    if (month > 2 && month < 10) return true;
    if (month === 2) return day >= nthSunday(year, 2, 2);
    return day < nthSunday(year, 10, 1);
  }

  /* Which category is treated as a live, attend-in-real-time event. Only these
     ever show the "Happening Now" state; everything else hands straight over to
     the next countdown the moment its start time passes. */
  var LIVE_CATEGORY = 'community';

  /* How long a live Community event keeps saying it's live. Deliberately a
     constant rather than a theme setting: Henry asked for exactly one hour,
     and a slider that can drift to another value is a trap — a stale setting
     silently made events look live for hours. */
  var LIVE_WINDOW_MS = 60 * 60 * 1000;

  /* UTC offset for a time string's named zone, or null when it names none
     (in which case the time is read as the viewer's own local time). */
  function zoneOffsetFor(t, y, mo, d) {
    if (/\b(utc|gmt)\b/i.test(t)) return 0;
    var zone = t.match(/\b([ecmp])([sd])?t\b/i);
    if (!zone) return null;
    var base = ZONE_STANDARD_OFFSETS[zone[1].toLowerCase()];
    var marker = zone[2] ? zone[2].toLowerCase() : '';
    var daylight = marker === 'd' || (marker === '' && isUsDst(y, mo, d));
    return base + (daylight ? 1 : 0);
  }

  /* Midnight at the end of the event's own day, in the event's own timezone.
     Used to decide how long it stays listed, so an evening ET event doesn't
     vanish for members whose local date has already rolled over. */
  function eventDayEnd(date, timeStr) {
    var y = date.getFullYear();
    var mo = date.getMonth();
    var d = date.getDate();
    var offset = timeStr ? zoneOffsetFor(String(timeStr), y, mo, d) : null;
    if (offset === null) return new Date(y, mo, d + 1).getTime();
    return Date.UTC(y, mo, d + 1, -offset, 0);
  }

  /* Turn "2026-09-06" + "8:00 PM EDT" into a real timestamp.
     A named US zone is honoured so the countdown is correct for members in any
     timezone; with no recognisable zone the time is read as the viewer's local
     time. Returns null when there is no usable time. */
  function eventTimestamp(date, timeStr) {
    if (!date) return null;
    if (!timeStr) return null;

    var t = String(timeStr).trim();
    var clock = t.match(/(\d{1,2})\s*:\s*(\d{2})\s*(a\.?m\.?|p\.?m\.?)?/i);
    if (!clock) return null;

    var hour = parseInt(clock[1], 10);
    var minute = parseInt(clock[2], 10);
    if (isNaN(hour) || isNaN(minute) || hour > 23 || minute > 59) return null;

    var meridiem = clock[3] ? clock[3].toLowerCase().replace(/\./g, '') : '';
    if (meridiem === 'pm' && hour < 12) hour += 12;
    if (meridiem === 'am' && hour === 12) hour = 0;

    var y = date.getFullYear();
    var mo = date.getMonth();
    var d = date.getDate();

    var offset = zoneOffsetFor(t, y, mo, d);
    if (offset === null) return new Date(y, mo, d, hour, minute).getTime();
    return Date.UTC(y, mo, d, hour - offset, minute);
  }

  /* Has this event's start time already passed? Used to drop "status" text
     like "Coming Soon" once it no longer makes sense — a real action with a
     link (e.g. "Watch VOD") still shows either way. An event with no usable
     time is treated as not started, so its label is never hidden. */
  function hasStarted(ev) {
    var ts = eventTimestamp(ev._date, ev.time);
    return ts !== null && ts <= Date.now();
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseDate(str) {
    if (!str) return null;
    var parts = String(str).trim().split('-');
    if (parts.length !== 3) return null;
    var y = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    var d = parseInt(parts[2], 10);
    if (!y || !m || !d) return null;
    var date = new Date(y, m - 1, d);
    if (isNaN(date.getTime())) return null;
    return date;
  }

  /* ── Repeating events (Henry, 2026-10-24: "every Tuesday at 7 p.m. Eastern … the rest of the month
     and all upcoming months") ──
     A block with Repeats = Every week is ONE block in the Theme Editor; here it becomes one event per
     week, from its Date onwards, until Repeat until (if set) or REPEAT_HORIZON_DAYS from today, so it
     never runs out. Each copy gets its own date and id (block id + date). Times written with a bare
     zone ("7:00 PM ET") get EDT or EST right for each date across the clock change. dashboard-events.js
     does the same expansion for the dashboard's This Week strip. */
  var REPEAT_HORIZON_DAYS = 400;
  function expandRepeats(list) {
    var out = [];
    var horizon = new Date();
    horizon.setHours(0, 0, 0, 0);
    horizon.setDate(horizon.getDate() + REPEAT_HORIZON_DAYS);
    list.forEach(function (ev) {
      if (ev.repeat !== 'weekly') { out.push(ev); return; }
      var until = parseDate(ev.repeat_until);
      var end = until && until < horizon ? until : horizon;
      var d = new Date(ev._date.getFullYear(), ev._date.getMonth(), ev._date.getDate());
      for (var n = 0; d <= end && n < 600; n++) {
        var copy = {};
        for (var k in ev) if (Object.prototype.hasOwnProperty.call(ev, k)) copy[k] = ev[k];
        copy._date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        copy.date = d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
        copy.id = ev.id + '-' + copy.date;
        out.push(copy);
        d.setDate(d.getDate() + 7);
      }
    });
    return out;
  }

  function sameDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function formatWeekday(date) {
    return date.toLocaleDateString('en-US', { weekday: 'long' });
  }

  function formatShortDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function monthAbbr(date) {
    return date.toLocaleDateString('en-US', { month: 'short' });
  }

  function dateKey(date) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  }

  function categoryColor(root, category) {
    var map = {
      stream: '--ec-color-stream',
      community: '--ec-color-community',
      new: '--ec-color-new'
    };
    var varName = map[category] || map[DEFAULT_CATEGORY];
    var value = getComputedStyle(root).getPropertyValue(varName);
    return value ? value.trim() : '#a855f7';
  }

  function categoryLabel(category) {
    return CATEGORY_LABELS[category] || CATEGORY_LABELS[DEFAULT_CATEGORY];
  }

  function matchesFilter(ev, filter) {
    if (filter === 'both') return true;
    return ev.game === filter || ev.game === 'both';
  }

  /* Readable category badge: colored dot + the category name spelled out */
  function buildBadge(color, category) {
    var badge = document.createElement('span');
    badge.className = 'm-events-cal__badge';
    badge.style.setProperty('--ec-badge-color', color);
    var dot = document.createElement('i');
    badge.appendChild(dot);
    badge.appendChild(document.createTextNode(categoryLabel(category)));
    return badge;
  }

  function buildActionMarkup(label, link) {
    if (!label) return '';
    if (link) {
      var a = document.createElement('a');
      a.href = link;
      a.className = 'm-events-cal__action m-events-cal__action--link';
      a.textContent = label;
      return a;
    }
    var span = document.createElement('span');
    span.className = 'm-events-cal__action m-events-cal__action--muted';
    span.textContent = label;
    return span;
  }

  /* Category whose posts get an "Officially LIVE" badge once they start,
     instead of just dropping their status text like everything else. */
  var PUBLISHED_LIVE_CATEGORY = 'new';

  /* A finished Community event says so, rather than going blank. */
  function buildEndedBadge() {
    var pill = document.createElement('span');
    pill.className = 'm-events-cal__ended-pill';
    pill.textContent = 'This event has ended';
    return pill;
  }

  /* Anything that hasn't started yet says so, automatically. This replaces the
     "Coming Soon" text Henry used to type into each event's label field by
     hand — which meant every event needed remembering, and the ones he forgot
     looked no different from ones already finished. Derived from the clock, so
     it can never be stale and disappears on its own the moment the event
     starts. After that the existing rules take over: Live right now, Officially
     LIVE, or This event has ended. */
  function buildUpcomingBadge() {
    var pill = document.createElement('span');
    pill.className = 'm-events-cal__upcoming-pill';
    pill.textContent = 'Upcoming';
    return pill;
  }

  /* The same glowing green pill used for "In-Season" in the site header,
     reused here so a published New Content post reads as officially live. */
  function buildOfficiallyLiveBadge(label) {
    var pill = document.createElement('span');
    pill.className = 'fs-live-pill m-events-cal__live-pill';
    var dot = document.createElement('span');
    dot.className = 'fs-live-dot';
    pill.appendChild(dot);
    pill.appendChild(document.createTextNode(label || 'Officially LIVE'));
    return pill;
  }

  function initEventsCalendar(root) {
    var dataEl = root.querySelector('[data-ec-events]');
    var events = [];
    if (dataEl) {
      try {
        events = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        events = [];
      }
    }

    events = events
      .map(function (ev) {
        ev._date = parseDate(ev.date);
        return ev;
      })
      .filter(function (ev) {
        return ev._date && ev.title;
      });

    events = expandRepeats(events);

    /* by day, then by start time, so two events on one day (a 7 PM film session and an
       8 PM tip drop) list, and count down, in the order they happen */
    events.sort(function (a, b) {
      return (a._date - b._date) ||
        ((eventTimestamp(a._date, a.time) || 0) - (eventTimestamp(b._date, b.time) || 0));
    });

    /* Which view opens first. Comes from the section's "Opens on" setting via
       data-ec-default-view, so the default lives in ONE place — the markup sets
       the matching is-active class and hidden panel from the same attribute.
       Anything other than "list" means the calendar. */
    var defaultView = root.getAttribute('data-ec-default-view') === 'list' ? 'list' : 'calendar';

    var state = {
      filter: 'both',
      view: defaultView,
      calYear: new Date().getFullYear(),
      calMonth: new Date().getMonth()
    };

    var filterBtns = root.querySelectorAll('[data-ec-filter]');
    var viewBtns = root.querySelectorAll('[data-ec-view]');
    var listViewEl = root.querySelector('[data-ec-list-view]');
    var calViewEl = root.querySelector('[data-ec-calendar-view]');
    var listEl = root.querySelector('[data-ec-list]');
    var gridEl = root.querySelector('[data-ec-grid]');
    var calTitleEl = root.querySelector('[data-ec-cal-title]');
    var upcomingEl = root.querySelector('[data-ec-upcoming]');
    var prevBtn = root.querySelector('[data-ec-prev]');
    var nextBtn = root.querySelector('[data-ec-next]');
    var nextUpEl = root.querySelector('[data-ec-next-up]');

    var showCountdown = root.getAttribute('data-ec-show-countdown') !== 'false';
    var countdownLabel = root.getAttribute('data-ec-countdown-label') || 'Next Up';
    var liveWindowMs = LIVE_WINDOW_MS;
    var countdownTimer = null;
    var statusTimer = null;

    /* Where an event sits in its own life:
         'upcoming' — hasn't started (or has no usable time)
         'live'     — a Community event inside its live window
         'ended'    — a Community event whose window has closed
         'started'  — any other category, past its start time          */
    function eventState(ev) {
      var ts = eventTimestamp(ev._date, ev.time);
      if (ts === null) return 'upcoming';
      var now = Date.now();
      if (now < ts) return 'upcoming';
      if (ev.category === LIVE_CATEGORY) {
        return now < ts + liveWindowMs ? 'live' : 'ended';
      }
      return 'started';
    }

    function filteredEvents() {
      return events.filter(function (ev) {
        return matchesFilter(ev, state.filter);
      });
    }

    /* Everything that hasn't finished its own day yet. Used by the list and the
       sidebar; the month grid still shows past events. Judged in the event's
       own timezone so an evening ET event stays listed for its whole evening
       no matter where the member is reading from. */
    function upcomingEvents() {
      var now = Date.now();
      return filteredEvents().filter(function (ev) {
        return eventDayEnd(ev._date, ev.time) > now;
      });
    }

    function renderEmpty(target, message) {
      var empty = document.createElement('div');
      empty.className = 'm-events-cal__empty';
      empty.textContent = message;
      target.appendChild(empty);
    }

    function renderList() {
      if (!listEl) return;
      listEl.innerHTML = '';
      var list = upcomingEvents();

      if (!list.length) {
        renderEmpty(listEl, 'No events scheduled right now — check back soon.');
        return;
      }

      list.forEach(function (ev) {
        var color = categoryColor(root, ev.category);

        var row = document.createElement('div');
        row.className = 'm-events-cal__list-row';
        row.style.setProperty('--ec-row-color', color);

        /* Big, glanceable date block */
        var dateBlock = document.createElement('div');
        dateBlock.className = 'm-events-cal__date-block';
        var month = document.createElement('span');
        month.className = 'm-events-cal__date-month';
        month.textContent = monthAbbr(ev._date);
        var day = document.createElement('span');
        day.className = 'm-events-cal__date-day';
        day.textContent = ev._date.getDate();
        dateBlock.appendChild(month);
        dateBlock.appendChild(day);
        row.appendChild(dateBlock);

        var info = document.createElement('div');
        info.className = 'm-events-cal__list-info';

        var title = document.createElement('p');
        title.className = 'm-events-cal__list-title';
        title.textContent = ev.title;
        info.appendChild(title);

        var meta = document.createElement('div');
        meta.className = 'm-events-cal__list-meta';

        var date = document.createElement('span');
        date.className = 'm-events-cal__list-date';
        date.textContent = formatWeekday(ev._date) + (ev.time ? ' · ' + ev.time : '');
        meta.appendChild(date);
        meta.appendChild(buildBadge(color, ev.category));

        info.appendChild(meta);
        row.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'm-events-cal__list-actions';
        var rowState = eventState(ev);
        var rowStarted = rowState !== 'upcoming';
        var left = (ev.left_link || !rowStarted) ? buildActionMarkup(ev.left_label, ev.left_link) : '';
        var right = (ev.right_link || !rowStarted) ? buildActionMarkup(ev.right_label, ev.right_link) : '';
        if (left) actions.appendChild(left);
        if (right) actions.appendChild(right);
        /* An "Upcoming" pill says WHEN; a link says WHAT TO DO. They aren't
           alternatives, so an event that hasn't started yet keeps its pill
           whether or not it also carries a link. The live/ended badges stay
           mutually exclusive with the labels, because those genuinely do
           replace the action once an event is under way. */
        if (rowState === 'upcoming') {
          actions.appendChild(buildUpcomingBadge());
        } else if (!left && !right) {
          if (rowState === 'live') {
            actions.appendChild(buildOfficiallyLiveBadge('Live right now'));
          } else if (rowState === 'ended') {
            actions.appendChild(buildEndedBadge());
          } else if (rowState === 'started' && ev.category === PUBLISHED_LIVE_CATEGORY) {
            actions.appendChild(buildOfficiallyLiveBadge());
          }
        }
        if (actions.childNodes.length) row.appendChild(actions);

        listEl.appendChild(row);
      });
    }

    function renderCalendar() {
      if (!gridEl) return;
      gridEl.innerHTML = '';
      calTitleEl.textContent = MONTH_NAMES[state.calMonth] + ' ' + state.calYear;

      var list = filteredEvents();
      var eventsByDay = {};
      list.forEach(function (ev) {
        var key = dateKey(ev._date);
        if (!eventsByDay[key]) eventsByDay[key] = [];
        eventsByDay[key].push(ev);
      });

      var firstOfMonth = new Date(state.calYear, state.calMonth, 1);
      var startWeekday = firstOfMonth.getDay();
      var gridStart = new Date(state.calYear, state.calMonth, 1 - startWeekday);
      var today = new Date();

      /* Only render the weeks this month actually touches — no empty trailing row */
      var daysInMonth = new Date(state.calYear, state.calMonth + 1, 0).getDate();
      var totalCells = Math.ceil((startWeekday + daysInMonth) / 7) * 7;

      for (var i = 0; i < totalCells; i++) {
        var cellDate = new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + i);
        var cell = document.createElement('div');
        cell.className = 'm-events-cal__day';
        if (cellDate.getMonth() !== state.calMonth) cell.classList.add('is-outside');
        if (sameDay(cellDate, today)) cell.classList.add('is-today');

        var num = document.createElement('span');
        num.className = 'm-events-cal__day-num';
        num.textContent = cellDate.getDate();
        cell.appendChild(num);

        var dayEvents = eventsByDay[dateKey(cellDate)] || [];
        if (dayEvents.length) {
          var chips = document.createElement('div');
          chips.className = 'm-events-cal__day-chips';

          dayEvents.slice(0, 2).forEach(function (ev) {
            var link = ev.right_link || ev.left_link;
            var chip = link ? document.createElement('a') : document.createElement('span');
            if (link) chip.href = link;
            chip.className = 'm-events-cal__chip';
            chip.style.setProperty('--ec-chip-color', categoryColor(root, ev.category));
            chip.textContent = ev.chip_label || ev.title;
            chip.title = ev.title + (ev.time ? ' — ' + ev.time : '');
            chips.appendChild(chip);
          });

          if (dayEvents.length > 2) {
            var more = document.createElement('span');
            more.className = 'm-events-cal__chip m-events-cal__chip--more';
            more.textContent = '+' + (dayEvents.length - 2) + ' more';
            chips.appendChild(more);
          }

          cell.appendChild(chips);
        }

        gridEl.appendChild(cell);
      }
    }

    function renderUpcoming() {
      if (!upcomingEl) return;
      upcomingEl.innerHTML = '';
      var upcoming = upcomingEvents().slice(0, 6);

      if (!upcoming.length) {
        renderEmpty(upcomingEl, 'Nothing scheduled yet — new events get posted here.');
        return;
      }

      upcoming.forEach(function (ev) {
        var color = categoryColor(root, ev.category);

        var item = document.createElement('div');
        item.className = 'm-events-cal__upcoming-item';

        var badgeRow = document.createElement('div');
        badgeRow.className = 'm-events-cal__upcoming-badge-row';
        badgeRow.appendChild(buildBadge(color, ev.category));
        item.appendChild(badgeRow);

        var title = document.createElement('p');
        title.className = 'm-events-cal__upcoming-title';
        title.textContent = ev.title;
        item.appendChild(title);

        var date = document.createElement('p');
        date.className = 'm-events-cal__upcoming-date';
        date.textContent = formatShortDate(ev._date) + (ev.time ? ' · ' + ev.time : '');
        item.appendChild(date);

        /* Sidebar is a quick "what's next" glance, so it shows a single action —
           the clickable one where there is one. The list view shows them all. */
        var itemState = eventState(ev);
        var itemStarted = itemState !== 'upcoming';
        var primary = '';
        if (ev.right_label && ev.right_link) {
          primary = buildActionMarkup(ev.right_label, ev.right_link);
        } else if (ev.left_label && ev.left_link) {
          primary = buildActionMarkup(ev.left_label, ev.left_link);
        } else if (!itemStarted && ev.right_label) {
          primary = buildActionMarkup(ev.right_label, '');
        } else if (!itemStarted && ev.left_label) {
          primary = buildActionMarkup(ev.left_label, '');
        } else if (itemState === 'live') {
          primary = buildOfficiallyLiveBadge('Live right now');
        } else if (itemState === 'ended') {
          primary = buildEndedBadge();
        } else if (itemStarted && ev.category === PUBLISHED_LIVE_CATEGORY) {
          primary = buildOfficiallyLiveBadge();
        } else if (!itemStarted) {
          primary = buildUpcomingBadge();
        }

        /* Same rule as the rows: the pill is a state, not an action, so it
           rides along with a link rather than being replaced by one. */
        var pill = (!itemStarted && primary && primary.className &&
                    primary.className.indexOf('upcoming-pill') === -1)
                   ? buildUpcomingBadge()
                   : null;

        if (primary) {
          var actions = document.createElement('div');
          actions.className = 'm-events-cal__upcoming-actions';
          actions.appendChild(primary);
          if (pill) actions.appendChild(pill);
          item.appendChild(actions);
        }

        upcomingEl.appendChild(item);
      });
    }

    /* ── Next-event countdown ───────────────────────────────────────────── */

    /* What the card should feature right now. An event that has started but is
       still inside its live window wins, so members see "Happening Now" while
       it's actually on — only then does the card move to the next countdown. */
    function pickNextEvent() {
      var list = upcomingEvents();
      if (!list.length) return null;

      var now = Date.now();
      var timed = list.map(function (ev) {
        return { ev: ev, ts: eventTimestamp(ev._date, ev.time) };
      });

      var i;

      /* 1. A live-category event currently on air. Other categories never take
            this branch — they hand straight over to the next countdown. */
      for (i = 0; i < timed.length; i++) {
        if (
          timed[i].ev.category === LIVE_CATEGORY &&
          timed[i].ts !== null &&
          timed[i].ts <= now &&
          now < timed[i].ts + liveWindowMs
        ) {
          return { ev: timed[i].ev, ts: timed[i].ts, live: true };
        }
      }

      /* 2. Otherwise count down to the soonest one still ahead. */
      for (i = 0; i < timed.length; i++) {
        if (timed[i].ts !== null && timed[i].ts > now) {
          return { ev: timed[i].ev, ts: timed[i].ts, live: false };
        }
      }

      /* 3. An event today with no usable time — show it without a clock. */
      for (i = 0; i < timed.length; i++) {
        if (timed[i].ts === null) {
          return { ev: timed[i].ev, ts: null, live: false };
        }
      }

      /* 4. Everything left today has already been and gone. */
      return null;
    }

    function renderNextUp() {
      if (!nextUpEl) return;

      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }

      if (!showCountdown) {
        nextUpEl.hidden = true;
        return;
      }

      var next = pickNextEvent();
      if (!next) {
        nextUpEl.hidden = true;
        nextUpEl.innerHTML = '';
        return;
      }

      var ev = next.ev;
      var color = categoryColor(root, ev.category);
      nextUpEl.hidden = false;
      nextUpEl.innerHTML = '';
      nextUpEl.style.setProperty('--ec-row-color', color);

      var inner = document.createElement('div');
      inner.className = 'm-events-cal__next-inner';

      /* Left: what and when */
      var main = document.createElement('div');
      main.className = 'm-events-cal__next-main';

      var label = document.createElement('div');
      label.className = 'm-events-cal__next-label';
      label.textContent = next.live ? 'Happening Now' : countdownLabel;
      main.appendChild(label);

      var title = document.createElement('p');
      title.className = 'm-events-cal__next-title';
      title.textContent = ev.title;
      main.appendChild(title);

      var when = document.createElement('p');
      when.className = 'm-events-cal__next-when';
      when.textContent =
        ev._date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) +
        (ev.time ? ' · ' + ev.time : '');
      main.appendChild(when);

      var badgeRow = document.createElement('div');
      badgeRow.className = 'm-events-cal__next-badge-row';
      badgeRow.appendChild(buildBadge(color, ev.category));
      main.appendChild(badgeRow);

      inner.appendChild(main);

      /* Right: the clock and the call to action */
      var side = document.createElement('div');
      side.className = 'm-events-cal__next-side';

      var units = [];
      if (next.ts !== null && !next.live) {
        var cdLabel = document.createElement('div');
        cdLabel.className = 'm-events-cal__cd-label';
        cdLabel.textContent = 'Starts in';
        side.appendChild(cdLabel);

        var clock = document.createElement('div');
        clock.className = 'm-events-cal__countdown';

        ['Days', 'Hours', 'Min', 'Sec'].forEach(function (word) {
          var unit = document.createElement('div');
          unit.className = 'm-events-cal__cd-unit';
          var num = document.createElement('span');
          num.className = 'm-events-cal__cd-num';
          num.textContent = '00';
          var wordEl = document.createElement('span');
          wordEl.className = 'm-events-cal__cd-word';
          wordEl.textContent = word;
          unit.appendChild(num);
          unit.appendChild(wordEl);
          clock.appendChild(unit);
          units.push(num);
        });

        side.appendChild(clock);
      } else if (next.live) {
        var liveEl = document.createElement('div');
        liveEl.className = 'm-events-cal__cd-live';
        liveEl.innerHTML = '<i></i>This event is live right now';
        side.appendChild(liveEl);
      }

      var action = '';
      if (ev.right_label && ev.right_link) {
        action = buildActionMarkup(ev.right_label, ev.right_link);
      } else if (ev.left_label && ev.left_link) {
        action = buildActionMarkup(ev.left_label, ev.left_link);
      }
      if (action) {
        var actionWrap = document.createElement('div');
        actionWrap.className = 'm-events-cal__next-actions';
        actionWrap.appendChild(action);
        side.appendChild(actionWrap);
      }

      inner.appendChild(side);
      nextUpEl.appendChild(inner);

      /* While an event is live, poll so that the moment its window closes the
         whole section updates — not just this card. The rows have to change
         too ("live right now" → "this event has ended"), so redraw everything
         rather than only re-picking the card. */
      if (next.live) {
        countdownTimer = setInterval(function () {
          if (Date.now() >= next.ts + liveWindowMs) scheduleRefresh();
        }, 1000);
        return;
      }

      if (!units.length) return;

      function tick() {
        var remaining = next.ts - Date.now();
        if (remaining <= 0) {
          /* Event just started — rebuild everything, so its row picks up the
             live badge at the same instant the card does. */
          scheduleRefresh();
          return;
        }
        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        units[0].textContent = pad2(days);
        units[1].textContent = pad2(hours);
        units[2].textContent = pad2(minutes);
        units[3].textContent = pad2(seconds);
      }

      tick();
      countdownTimer = setInterval(tick, 1000);
    }

    function renderAll() {
      renderList();
      renderCalendar();
      renderUpcoming();
      renderNextUp();
      lastStates = stateSignature();
    }

    /* ── Keeping the badges honest over time ──────────────────────────────
       An event crossing its start time, or a Community event's live hour
       running out, changes what the rows and the card should say. The
       countdown's own timer only redraws the card, so poll the whole set of
       states and redraw everything when any of them moves on.

       The visibility check matters more than it looks: browsers throttle
       timers in background tabs, so a page left open on another tab can sit
       there still claiming an event is live long after it finished. Coming
       back to the tab now re-checks immediately. */
    function stateSignature() {
      return events
        .map(function (ev) {
          return ev.id + ':' + eventState(ev);
        })
        .join('|');
    }

    var lastStates = null;

    function refreshIfStale() {
      if (stateSignature() !== lastStates) renderAll();
    }

    /* Redraw on the next tick rather than inline. The callers are inside the
       countdown's own interval, and renderAll() rebuilds that interval — going
       through a timeout keeps a render from restarting itself mid-flight. */
    function scheduleRefresh() {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
      setTimeout(renderAll, 0);
    }

    function onVisibility() {
      if (!document.hidden) refreshIfStale();
    }

    statusTimer = setInterval(refreshIfStale, 30000);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', refreshIfStale);

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.filter = btn.getAttribute('data-ec-filter');
        filterBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        renderAll();
      });
    });

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.view = btn.getAttribute('data-ec-view');
        viewBtns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        root.setAttribute('data-ec-view-mode', state.view);
        if (state.view === 'calendar') {
          listViewEl.hidden = true;
          calViewEl.hidden = false;
        } else {
          calViewEl.hidden = true;
          listViewEl.hidden = false;
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        state.calMonth -= 1;
        if (state.calMonth < 0) {
          state.calMonth = 11;
          state.calYear -= 1;
        }
        renderCalendar();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        state.calMonth += 1;
        if (state.calMonth > 11) {
          state.calMonth = 0;
          state.calYear += 1;
        }
        renderCalendar();
      });
    }

    /* Let the Theme Editor tear this instance down cleanly on re-render. */
    root.ecDestroy = function () {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
      if (statusTimer) {
        clearInterval(statusTimer);
        statusTimer = null;
      }
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', refreshIfStale);
    };

    /* Put the toggle and the two panels where state says, rather than trusting
       the markup to already agree. They are rendered to agree, but this is what
       makes the setting authoritative if the two ever drift. */
    viewBtns.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-ec-view') === state.view);
    });
    if (listViewEl) listViewEl.hidden = state.view !== 'list';
    if (calViewEl) calViewEl.hidden = state.view !== 'calendar';

    root.setAttribute('data-ec-view-mode', state.view);
    renderAll();
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll ? container.querySelectorAll('.m-events-cal') : [];
    Array.prototype.forEach.call(roots, initEventsCalendar);
    if (container.classList && container.classList.contains('m-events-cal')) {
      initEventsCalendar(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* The Shopify Theme Editor swaps a section's markup over AJAX when you edit
     it, which does not re-run this file — so re-initialise on its lifecycle
     events. Without this, editing a block leaves the calendar blank until the
     page is refreshed. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll
      ? event.target.querySelectorAll('.m-events-cal')
      : [];
    Array.prototype.forEach.call(roots, function (root) {
      if (typeof root.ecDestroy === 'function') root.ecDestroy();
    });
  });
})();
